import React from "react";

export const QuoteSectionTommy = () => {
  return (
    <div id="quote">
      <div className="container">
        <div className="citation-container">
          <blockquote className="citation">
            "Sie werden nie wieder zurückkommen - die Kinder, die man irgendwann und irgendwo auf der Welt getötet hat - die Kinder von gestern, von heute, von morgen. Man vergisst sie, weil man sie vergessen muss; sie sind unerwünscht, sie bedrohen die Glaubwürdigkeit unseres Handelns, unserer edlen Gefühle. Sie erinnern uns an das Unerwartete und Unberechenbare. <br/><br/>Ich bin einer von denen, die am Leben geblieben sind. Die Tragik meines Daseins ist die Tragik eines Fossils, dem später niemand glaubt, was es erzählt: Dinge, die unbequem sind, die Angst, Unbehagen und schlechtes Gewissen hervorrufen. Ich lebe, ich habe diese Chance bekommen, aber wo sind meine Eltern? Ich kann sie nicht sehen, lieben, hassen, verfluchen, streicheln, mit ihnen essen, sprechen, streiten. Sie wurden gezwungen dorthin zu gehen, wo keine Erinnerungen existieren. Nur die Träume sind da, die Träume, wo ich sie treffen kann. Sie kommen mit verschiedenen Gesichtern, die ich mir ausdenke, die ich haben will. Das einzige, was mir geblieben ist, was mir gehört, was man nur für mich gemacht hat, ist mein Buch, ein Buch von meinem Vater. Dort spüre ich ihn, seine Tränen, seine Hoffnung, seine Angst."
            <footer>
              <strong>Thomas Fritta-Haas</strong>
              22.1.1941 - 6.3.2015
            </footer>
          </blockquote>

          {/* Radio Prague Interview */}
          <div className="audio-container text-center" style={{ marginTop: "2rem" }}>
            <h4 className="text-center mb-3">Tommy im Jahr 2000 in Prag</h4>
            <audio 
              controls
              style={{ 
                maxWidth: "540px", 
                width: "100%",
                margin: "0 auto",
                borderRadius: "3px",
                boxShadow: "0 0 1px 0 rgba(0,0,0,0.5), 0 1px 10px 0 rgba(0,0,0,0.15)"
              }}
            >
              <source src="/img/press/thomas_radio_prag.mp3" type="audio/mpeg" />
              Your browser does not support the audio element.
            </audio>
          </div>

          {/* YouTube Video */}
          <div className="video-container text-center" style={{ marginTop: "2rem" }}>
            <h4 className="text-center mb-3">Tommy als Kind über seine Inhaftierung in Theresienstadt</h4>
            <iframe
              width="100%"
              style={{ 
                maxWidth: "540px", 
                height: "304px", 
                margin: "0 auto",
                border: "none",
                borderRadius: "3px",
                boxShadow: "0 0 1px 0 rgba(0,0,0,0.5), 0 1px 10px 0 rgba(0,0,0,0.15)"
              }}
              src="https://www.youtube.com/embed/283vw2v17L8"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
};
